import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import { useToast as useToast$1 } from '@chakra-ui/react';

var useToast = function () {
    var showToast = useToast$1();
    return {
        success: function (title, options) {
            showToast(__assign({ status: "success", title: title }, options));
        },
        error: function (title, options) {
            showToast(__assign({ status: "error", title: title }, options));
        },
        info: function (title, options) {
            showToast(__assign({ status: "info", title: title }, options));
        },
        warning: function (title, options) {
            showToast(__assign({ status: "warning", title: title }, options));
        },
    };
};

export { useToast as default };
//# sourceMappingURL=Toast.js.map
